module.exports = __webpack_public_path__ + "static/media/aside-2.761efd6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aside-2.jpg
// module id = 490
// module chunks = 33